// TypesPrestationsContent.js
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table as AntTable,
  Popconfirm,
  notification,
  Select,
  Checkbox,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined, SearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

import { TypesBenefsService } from "../Services/TypesBenefsServices";

const { Title } = Typography;
// Applique size="small" à tous les tableaux de cette page sans autre changement
const Table = ({ size = "small", ...props }) => <AntTable size={size} {...props} />;

const TypesDoc = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initialNewPrestation = {
    typedoc: "",
    libdoc: "",
    actif: false
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  const typesBenefsService = new TypesBenefsService();


  useEffect(() => {
    setLoading(true);
    typesBenefsService
      .getAllTypesDoc() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await typesBenefsService.updateTypesDoc(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData = await typesBenefsService.getAllTypesDoc();
        setTableData(updatedData);
        setSelectedRowData(null);
        notification.success({
          message: "Modification réussie",
          description: "Le document a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression du document",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => {
    try {
      await typesBenefsService.addTypesDoc(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await typesBenefsService.getAllTypesDoc();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "Le type a été ajouté avec succès.",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de l'ajout de type",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createPrestation :
  const handleSave = () => {
    createPrestation();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (typedoc) => {
    try {
      await typesBenefsService.deleteTypesDoc(typedoc);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData = await typesBenefsService.getAllTypesDoc();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "Le document a été supprimée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression du document :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression du document.",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false)
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"
  };

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await typesBenefsService.getAllTypesDoc(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) { }
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.typedoc,
      Libellé: item.libdoc,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_types.xlsx");
  };

  const columns = [
    {
      title: "Code Type",
      dataIndex: "typedoc",
      key: "typedoc",
      className: "small-cell",
      ellipsis: true,
      //align: "center",
      render: (text) => (
        <strong>{text}</strong>
      ),
    },
    {
      title: "Libellé",
      dataIndex: "libdoc",
      key: "libdoc",
      className: "small-cell",
      ellipsis: true,

    },
    {
      title: "Actif",
      dataIndex: "actif",
      key: "actif",
      className: "small-cell",
      ellipsis: true,
      render: (text, record) => (record.actif ? "Oui" : "Non"),

    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",

      // className: 'custom-action-column'
      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.typedoc)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >

                <Input
                  className="search-input-highlight"
                  placeholder="Rechercher..."
                  allowClear
                  prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                  style={{ width: 250 }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button className="buttonRefresh" onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            className="custom-header1-table compact-rows-table"
            bordered
            showSorterTooltip={false}
            /* size='small' */ columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}

          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}>
                    {" "}
                    Nouvelle Type
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="code">
                  <Input
                    placeholder="code ..."
                    //value={newPrestation.designation_article}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        typedoc: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Libellé">
                  <Input
                    placeholder="libellé ..."
                    //value={newPrestation.designation_article}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        libdoc: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item >
                  <Checkbox
                    checked={newPrestation.actif}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        actif: e.target.checked,
                      })
                    }
                  >
                    Actif
                  </Checkbox>
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    {" "}
                    Modification Types
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Code">
                  <Input
                    placeholder="code..."
                    value={
                      selectedRowData ? selectedRowData.typedoc : ""
                    }
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        typedoc: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Libellé">
                  <Input
                    placeholder="libellé..."
                    value={
                      selectedRowData ? selectedRowData.libdoc : ""
                    }
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        libdoc: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item >
                  <Checkbox
                    checked={selectedRowData ? selectedRowData.actif : false}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        actif: e.target.checked,
                      })
                    }
                  >
                    Actif
                  </Checkbox>
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TypesDoc;
